"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.accountGrade.list': 'Pakiety Cenowe',
    'route.accountGrade.create': 'Utwórz Pakiet Cenowy',
    'route.accountGrade.edit': 'Edytuj Pakiet Cenowy',
    'route.accountGrade.preview': 'Podgląd Pakietu Cenowego',
};
